var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M14.4719 7.20804C14.7622 7.47823 14.7785 7.93259 14.5083 8.22288L10.1053 12.9534C9.83506 13.2437 9.3807 13.26 9.09041 12.9898L6.46235 10.5436C6.17206 10.2734 6.15577 9.81906 6.42597 9.52877C6.69616 9.23849 7.15052 9.2222 7.44081 9.49239L9.54326 11.4493L13.4571 7.24442C13.7273 6.95413 14.1817 6.93784 14.4719 7.20804Z",
          fill: "#1BB157",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3.24414 2.95716C3.24414 2.66261 3.48292 2.42383 3.77747 2.42383H16.5775C16.872 2.42383 17.1108 2.66261 17.1108 2.95716V5.09049C17.1108 5.38505 16.872 5.62383 16.5775 5.62383H3.77747C3.48292 5.62383 3.24414 5.38505 3.24414 5.09049V2.95716ZM4.31081 3.49049V4.55716H16.0441V3.49049H4.31081Z",
          fill: "#1BB157",
        },
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M3.24414 15.7579C3.24414 15.4634 3.48292 15.2246 3.77747 15.2246H16.5775C16.872 15.2246 17.1108 15.4634 17.1108 15.7579V17.8913C17.1108 18.1858 16.872 18.4246 16.5775 18.4246H3.77747C3.48292 18.4246 3.24414 18.1858 3.24414 17.8913V15.7579ZM4.31081 16.2913V17.3579H16.0441V16.2913H4.31081Z",
          fill: "#1BB157",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }